import { HTTP_STATUS } from '@wareclouds/frontend-common';

export default function handleAxiosErrorMessage(error) {
  const { data, message } = error || {};
  const { UNAUTHORIZED, NOT_FOUND, INTERNAL_SERVER_ERROR } = HTTP_STATUS;

  if (data?.status === UNAUTHORIZED) {
    return 'UNAUTHORIZED';
  }

  if (data?.status === NOT_FOUND || data?.status === INTERNAL_SERVER_ERROR) {
    return 'GENERAL_ERROR';
  }

  if (data?.data?.message) {
    return data.data.message;
  }

  if (data?.data?.data) {
    return data.data.data;
  }

  if (message && message !== 'RequestError' && message !== 'AxiosError') {
    if (message.includes('timeout')) {
      return 'TIMEOUT_ERROR';
    }
    if (message.includes('Network Error')) {
      return 'NETWORK_ERROR';
    }
    return message;
  }

  return data?.data || 'GENERAL_ERROR';
}
